import { Divider, Grid, Stack, Typography } from '@mui/material';
import { SYNC_STATUSES, type Product, type SyncStatus } from '@weft/types';
import type { Optional } from '@weft/utils';
import { dayjs, isNotEmptyArray, isNotNullOrUndefined, raiseUnreachable, substringFromEnd } from '@weft/utils';
import { formatDate } from 'apps/app/src/utils/date';
import React from 'react';

type ContractPageAdvancedDetailsProps = {
  products: Product[];
  contractId: string;
  contractSyncStatus: SyncStatus;
  contractSyncStatusUpdatedAt: Optional<Date>;
};

export const ContractPageAdvancedDetails: React.FC<ContractPageAdvancedDetailsProps> = ({ products, contractId, contractSyncStatus, contractSyncStatusUpdatedAt }) => {
  return (
    <>
      {isNotEmptyArray(products) && (
        <>
          <Stack sx={{
            paddingTop: 1,
            paddingBottom: 1,
            paddingLeft: 4,
            fontSize: '0.875rem',
            textAlign: 'left',
            rowGap: 1,
          }}
          >
            <Typography> Products </Typography>

            {products.map((product) => (
              <Grid
                container
                key={product.id}
                spacing={2}
              >
                <Grid
                  item
                  xs={2}
                >
                  <Typography fontWeight={250} >
                    {product.variants[0].name}
                  </Typography>
                </Grid>

                <Grid
                  item
                  style={{ alignSelf: 'stretch' }}
                >
                  <Divider orientation="vertical" />
                </Grid>

                <Grid
                  item
                  xs={1}
                >
                  <Typography fontWeight={250}>
                    ERP ID
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={1}
                >
                  <Typography fontWeight={250}>
                    {product.erpMetadata?.erpId ?? 'N/A'}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Stack>
          <Divider />
        </>
      )}
      <Stack sx={{
        paddingTop: 2,
        paddingLeft: 4,
        fontSize: '0.875rem',
        textAlign: 'left',
        rowGap: 1,
      }}
      >
        <Typography >
          Synced Sales Order
        </Typography>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={2}
          >
            <Typography fontWeight={250} >
              {substringFromEnd(contractId, 5)}
            </Typography>
          </Grid>

          <Grid
            item
            style={{ alignSelf: 'stretch' }}
          >
            <Divider orientation="vertical" />
          </Grid>

          <Grid
            item
            xs={5}
          >
            <Typography fontWeight={250}>
              {`Status: ${formatSyncStatus(contractSyncStatus)} ${formatSyncStatusUpdatedAt(contractSyncStatusUpdatedAt)}`}
            </Typography>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

function formatSyncStatus(contractSyncStatus: SyncStatus): string {
  switch (contractSyncStatus) {
    case SYNC_STATUSES.None:
      return 'Not synced';
    case SYNC_STATUSES.Synced:
      return 'Success';
    case SYNC_STATUSES.Failed:
      return 'Failed';
    default:
      return raiseUnreachable(contractSyncStatus);
  }
}

function formatSyncStatusUpdatedAt(contractSyncStatusUpdatedAt: Optional<Date>): string {
  return isNotNullOrUndefined(contractSyncStatusUpdatedAt) ? formatDate(dayjs(contractSyncStatusUpdatedAt), 'MMM. D, YY') : '';
}